import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

declare var Chart: any;

@Component({
  selector: 'app-gauge-chart',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './gauge-chart.component.html',
  styleUrl: './gauge-chart.component.scss'
})
export class GaugeChartComponent implements OnInit {
  chart: any;
  @Input() gaugeRate: string = '';
  ngOnInit() {
    this.createChart();
  }

  createChart() {
    const ctx = document.getElementById('gaugeChart') as HTMLCanvasElement;
    if(!ctx) return;
    const gradient = ctx.getContext('2d').createLinearGradient(0, 0, 0, 200);
    gradient.addColorStop(0, '#FF6384');
    gradient.addColorStop(1, '#FF9F40');

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [Number(this.gaugeRate), 100 - Number(this.gaugeRate)],
          backgroundColor: [
            gradient,
            'rgb(242, 242, 242)'
          ],
          circumference: 180,
          rotation: 270,
          borderWidth: 0
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        cutout: '75%'
      }
    });
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  get formatGaugeRate():any
  {
    return (this.gaugeRate.replace(',', '.')) + '%';
  }
}
